export enum MetricUnit {
    Distance,
    Speed,
    Count,
    HeartRate,
    Other
}
